import React, {useContext, useState} from 'react';
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import {FormattedMessage, injectIntl} from "react-intl";
import Column from "@meridian/components/column";
import Text from "@amzn/meridian/text";
import {LidarOverviewContext} from "../context/LidarOverviewContext";
import {GlobalStateContext} from "../../../global/context/GlobalStateContext";
import {MILLISECONDS_IN_A_DAY} from "../../../util/Constants";

const ManageObstructionModal = (props) => {

    const {formatMessage} = props.intl;
    const {open, setOpen, selected, setSelected, enableObstruction} = props;
    const {showWarning, showCustomAlert} = useContext(GlobalStateContext);
    const {viewModel, dispatch} = useContext(LidarOverviewContext);

    const [obstructionDisabledUntil, setObstructionDisabledUntil] = useState(Date.now());

    const lidarControllerConfig = viewModel.lidarDeviceInformation[selected];

    const onCloseModal = () => {
        setOpen(false)
        setSelected(null);
    }

    const onClickConfirm = (obstructionDisabledUntil) => {
        showWarning(formatMessage({id: "lidarController.editWarning"}), () => {
            updateData({obstructionDisabledUntil:obstructionDisabledUntil})
            setOpen(false);
        });
    }

    const updateData = (configurations) => {
        dispatch({
            type: 'UPDATE_LIDAR_CONFIG', data: {
                dispatcher: dispatch, configurations: configurations, mac: lidarControllerConfig.mac,
                showCustomAlert: showCustomAlert
            }
        })
    }

    const prefill = () => {
        if (!selected)
            return;

        if (enableObstruction) {
            setObstructionDisabledUntil(Date.now());
        } else {
            setObstructionDisabledUntil(Date.now() + MILLISECONDS_IN_A_DAY); // disable obstruction for next 24 hours
        }

    }

    const getTitleId = () => {
        if (enableObstruction) {
            return "device.enable_obstruction_button_modal";
        } else {
            return "device.disable_obstruction_button_modal";
        }
    }

    return (
        <Modal
            title={formatMessage({id: getTitleId()})}
            open={open}
            onOpen={prefill}
            onClose={onCloseModal}
            scrollContainer="viewport"
            closeLabel="Close"
            bodySpacingInset="medium">
            <Column spacing={"medium"} spacingInset={"medium"}>
                <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                    {enableObstruction ?
                        <FormattedMessage id="modal.confirmenableobstructionupdate"
                                          defaultMessage="Please confirm that you wish to enable obstruction for the following device:"/>
                        :
                        <FormattedMessage id="modal.confirmdisableobstructionupdate"
                                          defaultMessage="Please confirm that you wish to disable obstruction for the following device:"/>
                    }
                </Text>
                <Text type={"h300"}>
                    {selected}
                </Text>
                    {enableObstruction ?
                        <Text type={"h300"}>
                        <FormattedMessage id="device.obstructionwillbeenabled"
                                          defaultMessage="Obstruction will be Enabled from now"/>
                        </Text>
                        :
                        <Text type={"h300"}>
                        <FormattedMessage id="device.obstructiondisableduntil"
                                          defaultMessage="Obstruction will be disabled in 1 minute and remain off until"/>
                        : {new Date(obstructionDisabledUntil).toUTCString()}
                        </Text>
                    }
            </Column>
            <ModalFooter>
                <Row alignmentHorizontal="right" widths="fit">
                    <Button type="secondary" size="medium" onClick={onCloseModal}>
                        <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                    </Button>
                    <Button type="primary" size="medium"
                            onClick={() => onClickConfirm(obstructionDisabledUntil)}>
                        <FormattedMessage id="modal.confirm" defaultMessage="Confirm"/>
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    )
}

export default injectIntl(ManageObstructionModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/modal/ManageObstructionModal.js